import { Component, AfterViewInit } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { blockTransition, fadeIn } from 'src/app/theme/utils/app-animation';
import { MenuService } from 'src/app/shared/services/menu.service';
import { IMenu, landingPageMenuId } from 'src/app/shared/responses/imenu';
import { SecurityService } from 'src/app/shared/services/security.service';
import { PersistentDbService } from 'src/app/shared/services/persistent-db.service';

@Component({
	selector: 'app-email-already-registered',
	templateUrl: './email-already-registered.component.html',
	styleUrls: ['./email-already-registered.component.scss'],
	animations: [blockTransition, fadeIn]
})
export class EmailAlreadyRegisteredComponent implements AfterViewInit {
	settings: Settings;
	activeMenu: IMenu = { id: 7000, parentId: landingPageMenuId, title: 'Email Already Exists', header: 'Account', routerLink: '/email-already-registered', icon: 'fingerprint', desc: 'Email already exists.' };

	constructor(private readonly securityService: SecurityService
		, public appSettings: AppSettings
		, public persistentDbService: PersistentDbService
		, public menuService: MenuService) {
		this.settings = this.appSettings.settings;
	}

	get email(): string {
		if (!!this.menuService) {
			if (!!this.menuService.userProfile) {
				return this.menuService.userProfile.email;
			}
		}
		return '';
	}

	get recommendedLogin(): string {
		if (!!this.menuService) {
			if (!!this.menuService.userProfile) {
				return this.menuService.userProfile.recommendedLogin;
			}
		}
		return '';
	}

	async logOutLogIn(): Promise<void> {
		// logout then re-login
		await this.persistentDbService.store(this.recommendedLogin);
		await this.securityService.logout();
	}

	ngAfterViewInit() {
		this.settings.loadingSpinner = false;
	}
}
